import React, { useState, useEffect } from 'react';

const HeroSection = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const scrollToCourses = () => {
        document.getElementById('courses').scrollIntoView({ behavior: 'smooth' });
    };

    const openWhatsApp = () => {
        window.open('https://wa.me/59894075255?text=Hola, me interesa conocer más sobre los cursos de la escuela', '_blank');
    };

    const fondo = require('../assets/imagenes/generales/fondoHero.jpg');

    return (
        <section className="relative min-h-screen overflow-hidden bg-black pt-16">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 z-0">
                <div
                    className="w-full h-full bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${fondo})`
                    }}
                />
                <div className="absolute inset-0 bg-black/60"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 min-h-screen flex text-center justify-center items-center px-4 bg-black/10 backdrop-blur-sm">
                <div className="text-center max-w-6xl mx-auto w-full">
                    <div className={`transform transition-all duration-1500 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                        <h1 className="text-6xl sm:text-5xl md:text-6xl lg:text-8xl font-bold tracking-wide text-white mb-4 sm:mb-6 md:mb-4 leading-none font-serif">
                            ESCUELA
                        </h1>
                        <h2 className="text-3xl sm:text-3xl md:text-4xl lg:text-6xl font-semibold text-yellow-700 tracking-wide mb-8 sm:mb-10 md:mb-8 leading-none font-serif">
                            VERÓNICA DANDREA
                        </h2>
                        <div className="inline-block px-6 sm:px-8 md:px-10 py-3 sm:py-4 md:py-4 bg-secondary/95 backdrop-blur-sm rounded-full border border-primary shadow-xl">
                            <p className="text-gray-700 font-medium tracking-wide text-md sm:text-base md:text-lg">Academia Profesional de Belleza y Estética</p>
                        </div>
                    </div>

                    {/* Professional Value Proposition */}
                    <div className={`my-8 sm:my-12 md:my-12 transform transition-all duration-1500 delay-300 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                        <p className="text-md sm:text-xl md:text-2xl lg:text-3xl font-medium text-white leading-relaxed tracking-wide px-4">
                            Formamos profesionales de élite en la industria de la belleza
                        </p>
                    </div>

                    {/* Professional Call to Action Buttons */}
                    <div className={`space-y-4 sm:space-y-6 md:space-y-0 md:space-x-6 lg:space-x-8 md:flex md:justify-center transform transition-all duration-1500 delay-500 mb-12 sm:mb-16 md:mb-8 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                        <button
                            onClick={scrollToCourses}
                            className="group relative w-full mb-4 md:mb-0 md:w-auto px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-5 bg-primary text-white font-semibold tracking-wider text-md sm:text-base md:text-lg rounded-full hover:from-primary-light hover:to-primary transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl"
                        >
                            <span className="relative z-10 flex items-center justify-center space-x-2 sm:space-x-3">
                                <span>Ver Cursos</span>
                                <svg className="w-4 md:w-5 h-4 md:h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </span>
                            <div className="absolute inset-0 bg-white/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </button>

                        <button
                            onClick={openWhatsApp}
                            className="group relative w-full md:w-auto mt-4 px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-5 bg-secondary/90 border-2 border-primary text-primary font-semibold tracking-wider text-md sm:text-base md:text-lg rounded-full hover:bg-secondary-light transition-all duration-300 transform hover:scale-105 shadow-xl hover:shadow-2xl backdrop-blur-sm"
                        >
                            <span className="flex items-center justify-center space-x-2 sm:space-x-3">
                                <span>Consulta Personalizada</span>
                                <svg className="w-4 md:w-5 h-4 md:h-5" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.703" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Professional CSS for floating animation */}
            <style jsx>{`
                @keyframes float-professional {
                    0%, 100% {
                        transform: translateY(0px) rotate(0deg);
                        opacity: 0.3;
                    }
                    33% {
                        transform: translateY(-15px) rotate(90deg);
                        opacity: 0.6;
                    }
                    66% {
                        transform: translateY(5px) rotate(180deg);
                        opacity: 0.4;
                    }
                }
                .animate-float-professional {
                    animation: float-professional infinite ease-in-out;
                }
            `}</style>
        </section>
    );
};

export default HeroSection; 